<template>
  <section class="section-cards">
    <section-header :title="section.title" />
    <div
      v-if="showDescription(section) && isDesktop"
      v-dompurify-html="section.description"
      class="section-description"
    />

    <carousel
      ref="slider"
      class="cards-container"
      :navigation-enabled="showNavigation"
      :navigation-next-label="''"
      :navigation-prev-label="''"
      :pagination-enabled="false"
      :per-page-custom="[[320, 1], [768, 2.482], [991, 3]]"
      :scroll-per-page="isDesktop"
    >
      <slide
        v-for="(card, index) in section.items"
        :key="`card_${index}`"
      >
        <template v-if="card.link.href !== ''">
          <a
            :href="card.link.href"
            :target="card.link.target"
            :title="card.title"
            class="card-as-link"
          >
            <card
              v-bind="card"
              highlighted
            />
          </a>
        </template>
        <template v-else>
          <card
            v-bind="card"
            highlighted
          />
        </template>
      </slide>
    </carousel>
  </section>
</template>

<script>
  import get from 'lodash-es/get'
  import { mapGetters } from 'vuex'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: "WhyUsSection",
    components: {
      'card': () => import(/* webpackChunkName: "card-component" */ 'components/Card/Card'),
      'section-header': () => import(/* webpackChunkName: "index-section-header" */ 'containers/Pages/IndexPage/SectionHeader'),
      Carousel,
      Slide
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters('device', [
        'isMobile',
        'isDesktop'
      ]),
      showNavigation () {
        return this.isDesktop
      }
    },
    methods: {
      showDescription (section) {
        return get(section, 'description', '') !== ''
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .section-cards {

    .section-description {
      @include defaultFontValues($blue-dark, 22, 34, 300);
      padding: 0 12px;
      margin-bottom: 40px;

      @include bp-mf-desktop-large {
        padding: 0;
      }
    }

    .card-as-link {
      display: flex;
      height: 100%;
      text-decoration: none;
    }

    ::v-deep .card {
      max-width: 280px;
      margin-right: 15px;

      @include bp-mf-tablet {
        max-width: 280px;
        box-shadow: none;
      }

      @include bp-mf-desktop {
        max-width: 360px;
        min-height: 360px;
        height: 100%;
      }
    }

    ::v-deep .VueCarousel-inner {
      flex-basis: 295px !important;
      width: 295px;
      height: calc(100% + 22px);

      @include bp-mf-tablet {
        width: calc(100% + 22px);
        flex-basis: 50%!important;
        min-height: 360px;
      }

      @include bp-mf-desktop {
        width: calc(100% + 20px);
        flex-basis: 100% !important;
      }
    }

    ::v-deep .VueCarousel-slide {
      max-width: 295px;

      @include bp-mf-desktop {
        max-width: calc(100% / 3);
      }

      &:last-child {

        .card {
          margin-right: 0;
        }
      }
    }

    ::v-deep .VueCarousel-dot-container {
      margin-top: 0!important;
    }

    ::v-deep .VueCarousel-navigation .VueCarousel-navigation-button {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      box-shadow: 0 4px 16px 0 rgba(148, 158, 179, 0.2);
      background-color: white;
      top: 36%;

      &::before {
        @include icon-font-thin();
        color: $blue-medium;
        font-size: em(18);
        content: $icon-arrow-right-thin-medium;
      }

      &.VueCarousel-navigation-prev {
        left: 30px;

        @include bp-desktop-small {
          left: 40px;
        }

        &::before {
          transform: rotate(180deg);
        }
      }

      &.VueCarousel-navigation-next {
        right: 30px;

        @include bp-desktop-small {
          right: 40px;
        }
      }

      &.VueCarousel-navigation--disabled {
        opacity: 1!important;

        &::before {
          opacity: 0.2;
        }
      }
    }
  }
</style>
